import PropTypes from 'prop-types';
import EventCardsTypes from 'modules/event-cards/types.js';

/**
 * Selection card prop types shared by classic and avantgarde variants.
 *
 * @typedef SelectionCardPropTypes
 *
 * @property {string} eventId - Event id.
 * @property {string} marketId - Market id used to load market data.
 * @property {string} marketName - Market name shown on the card.
 * @property {string} selectionId - Selection id used to load the selection.
 * @property {string} selectionName - Selection name shown on the card.
 * @property {string} [promotionText] - Promotion copy shown on the card.
 * @property {string} [imgUrl] - Optional card background image.
 * @property {Mojito.Modules.EventCards.types.COLOR_MODES} [colorMode] - Card presentation mode.
 * @property {boolean} [shouldRequestData = true] - Whether the card requests event and market data.
 * @property {boolean} [reportLoadingStatus = false] - Passed through to the skeleton wrapper for PAGE_READY metrics.
 * @property {boolean} [showSkeleton = true] - Whether the skeleton shows while data loads.
 * @property {object | Function} [elementRef] - Ref to the rendered element.
 *
 * @memberof Mojito.Modules.EventCards.Selection
 */
export const propTypes = {
    eventId: PropTypes.string.isRequired,
    marketId: PropTypes.string.isRequired,
    marketName: PropTypes.string.isRequired,
    selectionId: PropTypes.string.isRequired,
    selectionName: PropTypes.string.isRequired,
    promotionText: PropTypes.string,
    imgUrl: PropTypes.string,
    colorMode: PropTypes.oneOf(Object.values(EventCardsTypes.COLOR_MODES)),
    shouldRequestData: PropTypes.bool,
    reportLoadingStatus: PropTypes.bool,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export const defaultProps = {
    shouldRequestData: true,
    reportLoadingStatus: false,
};
